var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.ast0{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n\t.ast1{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ast0",
    d: "M51.43,0h243.78h6.9v7.12v345.76V360h-6.9H51.43h-6.9v-7.12V7.12V0H51.43L51.43,0z M97.53,36.22v27.86h151.59 V36.22H97.53L97.53,36.22z M97.53,87.29v27.85h151.59V87.29H97.53L97.53,87.29z M97.53,138.36v27.85h151.59v-27.85H97.53 L97.53,138.36z M97.53,189.41v27.86h151.59v-27.86H97.53L97.53,189.41z M97.53,240.49v27.85h151.59v-27.85H97.53L97.53,240.49z  M97.53,291.54v27.86h151.59v-27.86H97.53L97.53,291.54z M288.32,14.24H58.33v331.53h229.99V14.24z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ast1",
    width: 360,
    height: 360
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllScan);
export default __webpack_public_path__ + "static/media/allScan.98e8653534a040ce3f6ffc0122eab4ec.svg";
export { ForwardRef as ReactComponent };